// extracted by mini-css-extract-plugin
module.exports = {"container":"BigCalendar_container__1WyrA","loading_indicator_container":"BigCalendar_loading_indicator_container__1bkcI","taken_slot":"BigCalendar_taken_slot__2t_50"};